type ConfirmInFlight = {
  current: boolean;
};

export const runLiveGameConfirmedAction = async ({
  confirmAction,
  inFlight,
  onConfirm,
  onPendingChange,
}: {
  confirmAction: () => Promise<boolean>;
  inFlight: ConfirmInFlight;
  onConfirm: () => Promise<void> | void;
  onPendingChange?: (pending: boolean) => void;
}) => {
  if (inFlight.current) {
    return false;
  }

  inFlight.current = true;
  onPendingChange?.(true);
  try {
    if (!(await confirmAction())) {
      return false;
    }

    await onConfirm();
    return true;
  } finally {
    inFlight.current = false;
    onPendingChange?.(false);
  }
};

type LiveGameExitClick = {
  currentTarget: {
    hash: string;
    pathname: string;
    search: string;
  };
  preventDefault: () => void;
};

export const handleLiveGameExitClick = ({
  confirmExit,
  event,
  gameOver,
  inFlight,
  navigate,
}: {
  confirmExit: () => Promise<boolean>;
  event: LiveGameExitClick;
  gameOver: boolean;
  inFlight: ConfirmInFlight;
  navigate: (target: string) => Promise<void> | void;
}) => {
  if (gameOver) {
    return Promise.resolve(false);
  }

  // A native link would otherwise navigate before the async modal resolves.
  event.preventDefault();
  const target =
    event.currentTarget.pathname + event.currentTarget.search + event.currentTarget.hash;

  return runLiveGameConfirmedAction({
    confirmAction: confirmExit,
    inFlight,
    onConfirm: () => navigate(target),
  });
};
